import React from 'react';
import { Panel, ListGroup, ListGroupItem, Pagination } from 'react-bootstrap';

class StatisticsQuestionSelect extends React.Component {
  questionsPerPage = 4;

  constructor(props) {
    super(props);

    this.state = {
      activePage: 1,
      questions: this.formatQuestions(props.questions || {})
    };

    this.setActivePage = this.setActivePage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.questions !== this.props.questions) {
      this.setState({
        questions: this.formatQuestions(nextProps.questions)
      });
    }
  }

  formatQuestions(questions) {
    return Object.keys(questions).map(key => {
      return {
        label: questions[key].text,
        value: key
      }
    });
  }

  getNumberOfPages() {
    return Math.ceil(this.state.questions.length / this.questionsPerPage);
  }

  getPageQuestions(page) {
    const { activePage } = this.state;

    const startIndex = this.questionsPerPage * (activePage -1);
    const endIndex = (this.questionsPerPage * activePage);

    return this.state.questions.slice(startIndex, endIndex);
  }

  setActivePage(activePage) {
    this.setState({ activePage: activePage });
  }

  renderQuestions(questionsPerPage) {
    return questionsPerPage.map(
      (question, index) => {
        const className = (question.value === this.props.highlighted) ? 'highlighted' : "";

        return (
          <ListGroupItem
            onClick={ () => this.props.onQuestionClick(question.value) }
            key={ question.value }
            className={ className }
          >
            <span> &#x25C6; { question.label }</span>
          </ListGroupItem>
        );
      }
    )
  }

  render() {
    const { open, header } = this.props;
    const activePage = this.state.activePage;
    const questionsPerPage = this.getPageQuestions(activePage);
    const nPages = this.getNumberOfPages();

    return (
      <div className="question-stack">
        <Panel
          className={ open ? "panel-opened" : null }
          collapsible expanded={open}
          header={ header } eventKey="1"
        >
          <ListGroup fill>
            { this.renderQuestions(questionsPerPage) }
          </ListGroup>

          {
            nPages > 1
              ? <Pagination
                  bsSize="small" items={nPages}
                  activePage={ activePage } onSelect={ this.setActivePage }
                />
              : null
          }

        </Panel>
      </div>
    );
  }
}

export default StatisticsQuestionSelect;



// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticsQuestionSelect.js